<template>
	<div>

	</div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  created() {
  },
  mounted() {
    let login_token = this.$route.query._token;
    window.location.href = 'http://t.itaojin.cn/customer/action/login/verifyLogin?url=http://t.itaojin.cn/tjkStudy/hawkeye/voiceExam&token='+login_token
  },
  methods: {
  	
  } 
}
</script>


// WEBPACK FOOTER //
// ./src/page/hawkeye/blankLogin.vue